import ApiClient from './ApiClient';

/**
 * 手当申請（申請画面）
 * 手本: src/api/attendOvertimeApplication.ts
 *
 * ★ API のバージョンは GET / POST とも v1 のみ。
 *   残業申請の v2 / v3 は後方互換のための歴史的経緯であり、新規機能に旧版は無い。
 * ★ POST は明細を N 件送るため JSON で送信する（form-urlencoded では入れ子を送れない）。
 */

export const getAllowanceApplication = async (params: any): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(
    `/v1/attendAllowanceApplication/allowance/${companyCode}`, {}, params,
  );
  return response.data;
};

export const postAllowanceApplication = async (params: any): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.postJsonData(
    `/v1/attendAllowanceApplication/allowance/${companyCode}`, {}, params,
  );
  return response.data;
};

export default {
  getAllowanceApplication,
  postAllowanceApplication,
};
